import moment, { Moment } from 'moment'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DateRangeSelection from '../DateRangeSelection/DateRangeSelection'

import { BestSoldCards } from './BestSoldCards/BestSoldCards'
import { EmployeeReferenceCard } from './EmployeeReferenceCard/EmployeeReferenceCard'
import { OccupancyRateCard } from './OccupancyRateCard/OccupancyRateCard'
import { RevenueCard } from './RevenueCard/RevenueCard'
import {
  BottomLeftContainer,
  BottomRightContainer,
  DashBoardBestSoldTitle,
  DateRangeContainer,
  MainContainer,
  SideContainers,
  TopLeftContainer,
  TopRightContainer,
} from './styles'
import { TotalAppointmentsCards } from './TotalAppointmentsCard/TotalAppointmentsCards'

export const ReportDashboard: FunctionComponent = () => {
  const { t } = useTranslation()
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  const [from, setFrom] = useState<Moment>(moment().startOf('month'))
  const [to, setTo] = useState<Moment>(moment().endOf('month'))
  const [dashboardSettingsValue] = useState<string>('dashboard')

  useEffect(() => {
    window.addEventListener('resize', () => setWindowWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () =>
        setWindowWidth(window.innerWidth),
      )
    }
  }, [])

  return (
    <>
      <DateRangeContainer>
        <DateRangeSelection
          dashboardSettingsValue={dashboardSettingsValue}
          onSelected={(selectedSpan, selectedFrom, selectedTo) => {
            setFrom(selectedFrom)
            setTo(selectedTo)
          }}
          span="month"
          from={from}
          to={to}
          availableSpans={['month']}
        />
      </DateRangeContainer>
      <MainContainer windowWidth={windowWidth}>
        <SideContainers>
          <TopLeftContainer windowWidth={windowWidth}>
            <TotalAppointmentsCards
              from={from}
              to={to}
              windowWidth={windowWidth}
            />
            <OccupancyRateCard from={from} to={to} windowWidth={windowWidth} />
          </TopLeftContainer>

          <BottomLeftContainer windowWidth={windowWidth}>
            <RevenueCard />
          </BottomLeftContainer>
        </SideContainers>

        <SideContainers>
          <DashBoardBestSoldTitle>
            {t('Best sold').toUpperCase()}
          </DashBoardBestSoldTitle>

          <TopRightContainer>
            <BestSoldCards from={from} to={to} windowWidth={windowWidth} />
          </TopRightContainer>

          <BottomRightContainer windowWidth={windowWidth}>
            <EmployeeReferenceCard from={from} to={to} />
          </BottomRightContainer>
        </SideContainers>
      </MainContainer>
    </>
  )
}
